import React from 'react';
import PropTypes from 'prop-types';
import './ChordItem.css';

function ChordItem({ className, chord, playChords, isShowingAnswer}) {

	const onChordItemClick = () => {
		if (chord !== '0') {
			playChords([Number(chord)], 0, false); 
		}
	};

	return (
		<button
			className={`ChordItem-button ${className}`}
			onClick={onChordItemClick}
		>
			<span className="ChordItem-text">
				{isShowingAnswer ? chord : null}
			</span>
		</button>
	)
}
ChordItem.propTypes = {
	className: PropTypes.string.isRequired,
	chord: PropTypes.string.isRequired,
	playChords: PropTypes.func.isRequired,
	isShowingAnswer: PropTypes.bool.isRequired
};

export default ChordItem;
